import { matchRoute } from '@townsquare/router/primitives/match-route';
import { chatRoute } from '@townsquare/routes/chat';

export function useIsOnFullPageRovoChat(): boolean {
	return !!matchRoute([chatRoute], window.location.pathname);
}
